import React from "react";
import { LinkComponent } from "../../shared/LinkComponent";
import { useTranslation } from "react-i18next";
import { useSecureContext } from "../../../hooks/secure-http-context";
const SetPasswordSuccessComponent = ({}) => {
  const {
    t
  } = useTranslation();
  const {
    authService
  } = useSecureContext();
  const loginUrl = authService.getLoginUrl({
    useShortHand: true
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(LinkComponent, {
    to: loginUrl,
    type: "secondary",
    size: "sm",
    className: "font-semibold"
  }, t("Back to login"))));
};
export { SetPasswordSuccessComponent };